var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4669 30C7.57111 26.692 5.0677 23.2905 2.99398 19.59C1.76095 17.4034 0.696068 15.1606 0.229013 12.6936C-0.574321 8.41378 0.733433 4.82543 4.18964 2.20891C7.66452 -0.407596 11.5131 -0.706626 15.3429 1.3492C19.2101 3.40503 21.0597 6.8065 20.8541 11.1798C20.7981 12.5254 20.4245 13.8898 19.9387 15.1606C17.865 20.7301 14.3341 25.365 10.4669 30ZM10.4295 6.8065C8.37445 6.8065 6.69305 8.48854 6.71173 10.5444C6.71173 12.6002 8.39313 14.2822 10.4482 14.2822C12.5032 14.2822 14.1846 12.6002 14.1846 10.5444C14.1659 8.48854 12.5032 6.8065 10.4295 6.8065Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.08fbb43a0862cb1fd22a1aeeeb6740b2.svg";
export { ForwardRef as ReactComponent };